import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { CommunityComment } from '../../interfaces/homepage';
import { TextButton } from '../Button/variants';
import AuthorUnit from '../FeedItems/AuthorUnit';
import { SectionTitle } from './SectionTitle';

interface CommunityCommentsProps {
  communityComments: CommunityComment[];
}

const CommunityComments = ({ communityComments }: CommunityCommentsProps) => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.CommunityCommentsUnit,
  });

  return (
    <Track>
      <div className="mb-64">
        <SectionTitle title="Community Commentary" />
        {communityComments.map(({ id, title, excerpt, url, author }, index) => (
          <div
            key={`${id}-${index}`}
            className="mb-32 border-0 border-b border-solid border-grayscale-gray pb-32 last:mb-0 last:border-b-0 last:pb-0"
          >
            <AuthorUnit author={author} isRightRail />
            <TextButton
              onClickCapture={() =>
                trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title }))
              }
              as="link"
              href={url}
              className="my-24 font-suisse-neue"
            >
              <span className="italic">on… </span> {title}
            </TextButton>
            <div className="font-suisse-neue text-body-md text-primary-black">
              {ReactHtmlParser(excerpt)}
            </div>
          </div>
        ))}
      </div>
    </Track>
  );
};

export default CommunityComments;
